<div id="container">
    <nav id="main-menu" aria-label="main-menu">
        <app-header-menu></app-header-menu>
    </nav>
    <nav id="footer-menu" aria-label="footer-menu">
        <app-footer-menu></app-footer-menu>
    </nav>
</div>

<!-- Dialogs -->
<app-no-network-dialog></app-no-network-dialog>
<app-no-server-dialog></app-no-server-dialog>
<app-no-roles-dialog></app-no-roles-dialog>
<app-browser-not-compatible-dialog></app-browser-not-compatible-dialog>
